module.exports = __webpack_public_path__ + "static/media/468x60_0063_en.b285b776.jpg";